import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { createStore, combineReducers } from 'redux'
import { Provider } from 'react-redux'
import languageReducer from './store/languageReducer'
import reportWebVitals from './reportWebVitals';

const store = createStore(

  combineReducers({
    languageReducer,
    }), window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  )

ReactDOM.render(

  <Provider store={store}>
    <App />
  </Provider>
  
  ,document.getElementById('root')
);


reportWebVitals();
